var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBgSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 443,
    viewBox: "0 0 375 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1002_5065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.042 73.1787C405.042 137.692 231.87 326.046 144.908 201.177C88.6274 120.364 -43.1635 126.893 -43.1635 62.3803C-43.1635 -2.13267 101.851 -43.6323 209.723 -43.6323C317.595 -43.6323 405.042 8.66581 405.042 73.1787Z",
    fill: "#7058FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1002_5065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.163 -13.8878C202.163 50.6251 451.453 75.1936 343.581 75.1936C235.709 75.1936 -148.484 128.961 -148.484 64.4484C-148.484 -0.0645905 -101.027 -130.699 6.8443 -130.699C114.716 -130.699 202.163 -78.4008 202.163 -13.8878Z",
    fill: "#16138C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1002_5065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.114 6.77246C464.114 88.7708 294.42 186.225 186.597 186.225C78.7727 186.225 222.073 123.764 222.073 41.7661C222.073 -40.2323 125.988 -176 233.812 -176C341.635 -176 464.114 -75.2259 464.114 6.77246Z",
    fill: "#9E86FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1002_5065",
    x: -243.164,
    y: -243.632,
    width: 848.205,
    height: 686.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1002_5065"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1002_5065",
    x: -348.484,
    y: -330.699,
    width: 919.14,
    height: 626.897,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1002_5065"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1002_5065",
    x: -53.5882,
    y: -376,
    width: 717.702,
    height: 762.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1002_5065"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBgSmall);
export default __webpack_public_path__ + "static/media/send-bg-small.abc10d29892176451b4a1aa066629c7c.svg";
export { ForwardRef as ReactComponent };